import * as Constants from '../../Pages/Constants';
import { withStyles } from '@material-ui/core';
import { useCallback } from 'react';
import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from 'react-intl';
import { Row, Col, Card } from 'antd'
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Range, getTrackBackground } from 'react-range';
import PostDataController from '../../Controller/PostDataController.js';

const SF36Form = (props) => {

  const { classes } = props;
  const [step, setStep] = useState(0);
  const optionsTwo = [0,1];
  const optionsLabels = ["one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];
  const [optionSelected, setOptionSelected] = useState(["-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1","-1"]);
  const [message, setMessage] = useState("");

  const sendingForm = async () => {
    let to_send = [{label: "one", value:0}, {label:"two", value:0}, {label:"three_one", value:0}, {label:"three_two", value:0}, {label:"three_three", value:0}, {label:"three_four", value:0}, {label:"three_five", value:0}, {label:"three_six", value:0}, {label:"three_seven", value:0}, {label:"three_eight", value:0}, {label:"three_nine", value:0}, {label:"three_ten", value:0}, {label:"four_one", value:0}, {label:"four_two", value:0}, {label:"four_three", value:0}, {label:"four_four", value:0}, {label:"five_one", value:0}, {label:"five_two", value:0}, {label:"five_three", value:0}, {label:"six", value:0}, {label:"seven", value:0}, {label:"eight", value:0}, {label:"nine_one", value:0}, {label:"nine_two", value:0}, {label:"nine_three", value:0}, {label:"nine_four", value:0}, {label:"nine_five", value:0}, {label:"nine_six", value:0}, {label:"nine_seven", value:0}, {label:"nine_eight", value:0}, {label:"nine_nine", value:0}, {label:"ten", value:0}, {label:"eleven_one", value:0}, {label:"eleven_two", value:0}, {label:"eleven_three", value:0}, {label:"eleven_four", value:0}, {label:"registered_by", value:0}];

    let index = 0
    to_send.forEach(obj => {
      to_send[index].value = parseInt(optionSelected[index])
      index++      
    })
    to_send.unshift({label: "form_type", value:"SF36"});                                   // add form_type on index 0
    index = to_send.findIndex(result => result.label === "registered_by")
    to_send[index].value = props.accountInformation.username;

    let current_Date = new Date()                                                                         // Get current date      
    await PostDataController.post_observation(current_Date, to_send, "health_form", props.id_patient);    // Send data in backend
    await props.update(current_Date, to_send, props.BannerDisplayedAlerts);                                             // update display
    props.cancelPopup();
  }

  const findOptionsSelectedIndexes = () => {
    switch (step) {
      case 0:
        return ([0, 1])
      case 1:
        return ([1, 2])
      case 2:
        return ([2, 12])
      case 3:
        return ([12, 19])
      case 4:
        return ([19, 21])
      case 5:
        return ([21, 22])
      case 6:
        return ([22, 31])
      case 7:
        return ([31, 32])
      case 8:
        return ([32, 35])
    }
  }

  const changeStep = (direction) => {
    if (direction === "next") {

      // check that all questions of the page has been answered
      let notSelected = true
      let i = findOptionsSelectedIndexes()
      while (notSelected && i[0] < i[1]) {
        if (optionSelected[i[0]] === "-1") {
          notSelected = false
        }
        i[0]++;
      }
      if (notSelected === false) {
        setMessage(<FormattedMessage id="mdasi.form.error.noselection" defaultMessage="Please select an option for all questions."/>)
      }
      else {
        if (step === optionsLabels.length-1) {
          sendingForm()
        }
        else {
          setMessage("");
          setStep(step+1);
        }
      }
    }
    else if (direction === "previous") {
      setMessage("");
      setStep(step-1);
    }
  }

  const toggleRadio = (e,i) => {
    let newOptionSelected = [...optionSelected]
    newOptionSelected[i] = e.target.value
    setOptionSelected(newOptionSelected)
  }

  const toggleSelect = (e,i) => {
    let newOptionSelected = [...optionSelected]
    newOptionSelected[i] = e.target.value
    setOptionSelected(newOptionSelected)
  }

  const generateOptionsTerms = (option, size_one, size_two) => {
    return (
      <Row style={{width:"100%", color: "black"}}>
        <Col xs={size_one}>
        </Col>
        {option.map((option, i) => (
          <Col xs={size_two}>
            {option}
          </Col>
        ))}
      </Row>
    )
  }

  const generateOneRadio = (name, i, ligne, option, radio_number, size_one, size_two, fontWeight) => {
    let display = name + '. '
      return (
      <div>
        <Row style={{width:"100%", color: "black", fontWeight: fontWeight ? 'bold' : 'normal'}}>
          <Col xs={size_one}>
            <div style={{textAlign: 'justify'}}>
              {name !== "" ?
                display += props.intl.formatMessage({id: ligne.props.id})
                :
                display = props.intl.formatMessage({id: ligne.props.id})
              }
            </div>
          </Col>
          {option.map((option, j) => (
            <Col xs={size_two} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <input type="radio" name={radio_number} value={String(j)} onChange={(e) => toggleRadio(e,i)} checked={String(j) === optionSelected[i]}/><br/>
            </Col>
          ))}
        </Row>
      </div>
      )
    }

  const generateSelect = (name, i, ligne, option, radio_number, size_one, size_two, fontWeight) => {
    return (
      <div>
        <Row style={{width:"100%", color: "black", fontWeight: fontWeight ? 'bold' : 'normal'}}>
          <Col xs={size_one}>
            <div style={{textAlign: 'left'}}>
              {name}. {ligne}
            </div>
          </Col>
            <Col xs={size_two} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <select value={optionSelected[i]} onChange={(e) => toggleSelect(e, i)} id={"answer_selector"+i} name={"answer_selector"+i} style={{maxWidth:"100%", margin:"0%"}}>
              <option value={'-1'} key={-1}>{}</option>
              {option.map((option, j) => (
                <option value={j} key={j}>{props.intl.formatMessage({id: option.props.id})}</option>
          ))}
            </select>
          </Col>
        </Row>
      </div>
    )
  }

  const generatePageOne = () => {
    const lignes = [
      <FormattedMessage id="sf36.form.one" defaultMessage="Question_01"/>,
    ];
    const optionsQuestionOne = [
      <FormattedMessage id="sf36.form.option.one.one" defaultMessage="Answer_01"/>,
      <FormattedMessage id="sf36.form.option.one.two" defaultMessage="Answer_02"/>,
      <FormattedMessage id="sf36.form.option.one.three" defaultMessage="Answer_03"/>,
      <FormattedMessage id="sf36.form.option.one.four" defaultMessage="Answer_04"/>,
      <FormattedMessage id="sf36.form.option.one.five" defaultMessage="Answer_05"/>,
    ]
    return (
      <div>
        <b style={{color: "black"}}>{message}</b>
        {generateSelect(1, 0, lignes[0], optionsQuestionOne, "one", 17, 7)}
      </div>
    )
  }

  const generatePageTwo = () => {
    const lignes = [
      <FormattedMessage id="sf36.form.two" defaultMessage="Question_02"/>,
    ];
    const optionsQuestionTwo = [
      <FormattedMessage id="sf36.form.option.two.one" defaultMessage="Answer_01"/>,
      <FormattedMessage id="sf36.form.option.two.two" defaultMessage="Answer_02"/>,
      <FormattedMessage id="sf36.form.option.two.three" defaultMessage="Answer_03"/>,
      <FormattedMessage id="sf36.form.option.two.four" defaultMessage="Answer_04"/>,
      <FormattedMessage id="sf36.form.option.two.five" defaultMessage="Answer_05"/>,
    ]
    return (
      <div>
        <b style={{color: "black"}}>{message}</b>
        {generateSelect(2, 1, lignes[0], optionsQuestionTwo, "two", 17, 7)}
      </div>
    )
  }

  const generatePageThree = () => {
    const lignes = [
      <FormattedMessage id="sf36.form.three.one" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.three.two" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.three.three" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.three.four" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.three.five" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.three.six" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.three.seven" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.three.eight" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.three.nine" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.three.ten" defaultMessage="The most important fatigue?"/>,
    ];
    const optionsQuestionThree = [
      <FormattedMessage id="sf36.form.option.three.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.three.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.three.three" defaultMessage="The most severe nausea?"/>,
    ]
    return (
      <div>
        <b style={{color: "black"}}>{message}</b>
        {generateOneRadio("", -1, <FormattedMessage id="sf36.form.three" defaultMessage="The most important fatigue?"/>, [], "two", 30, 0, "bold")}
        {generateSelect(3, 2, lignes[0], optionsQuestionThree, "three_one", 17, 7)}
        {generateSelect(4, 3, lignes[1], optionsQuestionThree, "three_two", 17, 7)}
        {generateSelect(5, 4, lignes[2], optionsQuestionThree, "three_three", 17, 7)}
        {generateSelect(6, 5, lignes[3], optionsQuestionThree, "three_four", 17, 7)}
        {generateSelect(7, 6, lignes[4], optionsQuestionThree, "three_five", 17, 7)}
        {generateSelect(8, 7, lignes[5], optionsQuestionThree, "three_six", 17, 7)}
        {generateSelect(9, 8, lignes[6], optionsQuestionThree, "three_seven", 17, 7)}
        {generateSelect(10, 9, lignes[7], optionsQuestionThree, "three_eight", 17, 7)}
        {generateSelect(11, 10, lignes[8], optionsQuestionThree, "three_nine", 17, 7)}
        {generateSelect(12, 11, lignes[9], optionsQuestionThree, "three_ten", 17, 7)}
      </div>
    )
  }

  const generatePageFour = () => {
    const lignes = [
      <FormattedMessage id="sf36.form.four.one" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.four.two" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.four.three" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.four.four" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.five.one" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.five.two" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.five.three" defaultMessage="The most important fatigue?"/>,
    ];
    const optionsQuestionFour = [
      <FormattedMessage id="sf36.form.option.four.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.four.two" defaultMessage="Sleep disorders?"/>,
    ]
    return (
      <div>
        <b style={{color: "black"}}>{message}</b>
        {generateOneRadio("", -1, <FormattedMessage id="sf36.form.four" defaultMessage="The most important fatigue?"/>, [], "two", 30, 0, "bold")}
        {generateOptionsTerms(optionsQuestionFour, 15, 3)}
        {generateOneRadio(13, 12, lignes[0], optionsTwo, "four_one", 15, 3)}
        {generateOneRadio(14, 13, lignes[1], optionsTwo, "four_two", 15, 3)}
        {generateOneRadio(15, 14, lignes[2], optionsTwo, "four_three", 15, 3)}
        {generateOneRadio(16, 15, lignes[3], optionsTwo, "four_four", 15, 3)}
        <br/>
        {generateOneRadio("", -1, <FormattedMessage id="sf36.form.five" defaultMessage="The most important fatigue?"/>, [], "two", 30, 0, "bold")}
        {generateOptionsTerms(optionsQuestionFour, 15, 3)}
        {generateOneRadio(17, 16, lignes[4], optionsTwo, "five_one", 15, 3)}
        {generateOneRadio(18, 17, lignes[5], optionsTwo, "five_two", 15, 3)}
        {generateOneRadio(19, 18, lignes[6], optionsTwo, "five_three", 15, 3)}
      </div>
    )
  }

  const generatePageFive = () => {
    const lignes = [
      <FormattedMessage id="sf36.form.six" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.seven" defaultMessage="The most important fatigue?"/>,
    ];
    const optionsQuestionSix = [
      <FormattedMessage id="sf36.form.option.six.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.six.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.six.three" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.six.four" defaultMessage="Sleep disorders?"/>,
    ]
    return (
      <div>
        <b style={{color: "black"}}>{message}</b>
        {generateSelect(20, 19, lignes[0], optionsQuestionSix, "six", 17, 7)}
        {generateSelect(21, 20, lignes[1], optionsQuestionSix, "seven", 17, 7)}
      </div>
    )
  }

  const generatePageSix = () => {
    const lignes = [
      <FormattedMessage id="sf36.form.eight" defaultMessage="The most important fatigue?"/>,
    ];
    const optionsQuestionEight = [
      <FormattedMessage id="sf36.form.option.eight.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.eight.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.eight.three" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.eight.four" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.eight.five" defaultMessage="Sleep disorders?"/>,
    ]
    return (
      <div>
        <b style={{color: "black"}}>{message}</b>
        {generateSelect(22, 21, lignes[0], optionsQuestionEight, "eight", 17, 7)}
      </div>
    )
  }

  const generatePageSeven = () => {
    const lignes = [
      <FormattedMessage id="sf36.form.nine.one" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.nine.two" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.nine.three" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.nine.four" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.nine.five" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.nine.six" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.nine.seven" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.nine.eight" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.nine.nine" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.ten" defaultMessage="The most important fatigue?"/>,
    ];
    const optionsQuestionNine = [
      <FormattedMessage id="sf36.form.option.nine.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.nine.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.nine.three" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.nine.four" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.nine.five" defaultMessage="The most severe nausea?"/>,
    ]
    return (
      <div>
        <b style={{color: "black"}}>{message}</b>
        {generateOneRadio("", -1, <FormattedMessage id="sf36.form.nine" defaultMessage="The most important fatigue?"/>, [], "two", 30, 0, "bold")}
        {generateSelect(23, 22, lignes[0], optionsQuestionNine, "nine_one", 17, 7)}
        {generateSelect(24, 23, lignes[1], optionsQuestionNine, "nine_two", 17, 7)}
        {generateSelect(25, 24, lignes[2], optionsQuestionNine, "nine_three", 17, 7)}
        {generateSelect(26, 25, lignes[3], optionsQuestionNine, "nine_four", 17, 7)}
        {generateSelect(27, 26, lignes[4], optionsQuestionNine, "nine_five", 17, 7)}
        {generateSelect(28, 27, lignes[5], optionsQuestionNine, "nine_six", 17, 7)}
        {generateSelect(29, 28, lignes[6], optionsQuestionNine, "nine_seven", 17, 7)}
        {generateSelect(30, 29, lignes[7], optionsQuestionNine, "nine_eight", 17, 7)}
        {generateSelect(31, 30, lignes[8], optionsQuestionNine, "nine_nine", 17, 7)}
      </div>
    )
  }

  const generatePageEight = () => {
    const lignes = [
      <FormattedMessage id="sf36.form.ten" defaultMessage="The most intense pain?"/>,
    ];
    const optionsQuestionTen = [
      <FormattedMessage id="sf36.form.option.nine.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.nine.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.nine.three" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.nine.four" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.nine.five" defaultMessage="The most severe nausea?"/>,
    ]
    return (
      <div>
        <b style={{color: "black"}}>{message}</b>
        {generateSelect(32, 31, lignes[0], optionsQuestionTen, "ten", 17, 7)}
      </div>
    )
  }

  const generatePageNine = () => {
    const lignes = [
      <FormattedMessage id="sf36.form.eleven.one" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.eleven.two" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.eleven.three" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="sf36.form.eleven.four" defaultMessage="The most important fatigue?"/>,
    ];
    const optionsQuestionEleven = [
      <FormattedMessage id="sf36.form.option.eleven.one" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.eleven.two" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.eleven.three" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="sf36.form.option.eleven.four" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="sf36.form.option.eleven.five" defaultMessage="The most severe nausea?"/>,
    ]
    return (
      <div>
        <b style={{color: "black"}}>{message}</b>
        {generateOneRadio("", -1, <FormattedMessage id="sf36.form.eleven" defaultMessage="The most important fatigue?"/>, [], "two", 30, 0, "bold")}
        {generateSelect(33, 32, lignes[0], optionsQuestionEleven, "eleven_one", 17, 7)}
        {generateSelect(34, 33, lignes[1], optionsQuestionEleven, "eleven_two", 17, 7)}
        {generateSelect(35, 34, lignes[2], optionsQuestionEleven, "eleven_three", 17, 7)}
        {generateSelect(36, 35, lignes[3], optionsQuestionEleven, "eleven_four", 17, 7)}
      </div>
    )
  }

  const generatePage = () => {
    switch(step) {
    case 0 :
      return (generatePageOne())
    case 1 :
      return (generatePageTwo())
    case 2 :
      return (generatePageThree())
    case 3 :
      return (generatePageFour())
    case 4 :
      return (generatePageFive())
    case 5 :
      return (generatePageSix())
    case 6 :
      return (generatePageSeven())
    case 7 :
      return (generatePageEight())
    case 8 :
      return (generatePageNine())
    default :
      return (null);
    }
  }

  const generateStep = () => {
    return (
      <div>
        <Row style={{ display: 'flex', justifyContent: 'center', fontWeight: "bold", fontSize:"2.2em", color: "black"}}>
            <FormattedMessage id="sf36.form.title.main" defaultMessage="Health Questionnaire (SF36)"/>
        </Row>
        <br/>
        <Row style={{ color: "black", display: 'flex', textAlign: 'justify'}}>
          <FormattedMessage id="eq5d.form.instruction.page" defaultMessage="Please select the ONE box that best describes your health TODAY."/>
        </Row>
        <br/>
        {generatePage()}
        <br/>
        <Button
          disabled={step===0}
          variant="contained"
          color="default"
          startIcon={<ArrowBackIcon />}
           onClick={() => changeStep("previous")}
        >
          <FormattedMessage id="eq5d.form.arrow.previous" defaultMessage="Previous"/>
        </Button>
        <Button
          variant="contained"
          color="default"
          startIcon={<ArrowForwardIcon />}
           onClick={() => changeStep("next")}
        >
          <FormattedMessage id="eq5d.form.arrow.next" defaultMessage="Next"/>
        </Button>
      </div>
    )
  }

  let generalFormWidth = "75%"
  if (props.screenSize.width < 800) {
    generalFormWidth = "100%"
  }
  return (
    <div className={classes.popup_background}>
      <div style={{ width:{generalFormWidth}, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form" style={{ borderRadius: "5px"}}>
          {generateStep()}
          <button onClick={props.cancelPopup} className="btn btn-danger">
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </button>
        </div>
      </div>
    </div>
  );

}
export default withStyles(Constants.styles)(SF36Form);
